import { useSelector } from 'react-redux';
import { allProvidersOpenedModalCount } from './slice';

export const useIsAnyModalOpen = (): boolean => {
  return !!useSelector(allProvidersOpenedModalCount);
};
